import React, { useState, useEffect } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string } from "yup";
import { toast } from "react-toastify";

const validationSchema = object().shape({
  vehicle_type: string().required("Vehicle Type is required"),
  ryder_charges: string().required("Ryder Charges is required"),
  gomak_commision: string().required("Gomak Commision is required"),
  ryder_gst: string().required("Ryder Gst is required"),
  gomak_gst: string().required("Gomak Gst is required"),
});

export const EditPricing = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const formik = useFormik({
    initialValues: {
      vehicle_type: "",
      ryder_charges: "",
      gomak_commision: "",
      ryder_gst: "",
      gomak_gst: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const payload = {
          vehicle_type: values.vehicle_type.trim(),
          ryder_charges: values.ryder_charges,
          gomak_commision: values.gomak_commision,
          ryder_gst: values.ryder_gst,
          gomak_gst: values.gomak_gst,
        };

        const response = await axiosInstance.put(
          `/admin/pricemaster/${id}/`,
          payload
        );

        if (response.data.status === "success") {
          toast.success("Pricing updated successfully!");
          setTimeout(() => navigate("/pricing"), 1500);
        } else {
          toast.error(response.data.message || "Failed to update Pricing.");
        }
      } catch (err) {
        console.error("❌ Error updating Pricing:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/pricing");
  };

  useEffect(() => {
    const fetchPricingDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/pricemaster/${id}`);
        if (res.data.status === "success" && res.data.data) {
          formik.setValues({
            vehicle_type: res.data.data.vehicle_type || "",
            ryder_charges: res.data.data.ryder_charges || "",
            gomak_commision: res.data.data.gomak_commision || "",
            ryder_gst: res.data.data.ryder_gst || "",
            gomak_gst: res.data.data.gomak_gst || "",
          });
        } else {
          toast.error("Failed to load Pricing details.");
        }
      } catch (err) {
        console.error("Error fetching Pricing data:", err);
        toast.error("Something went wrong while loading Pricing data.");
      }
    };

    fetchPricingDetails();
  }, [id]);
  return (
    <div className="addAdmin-container">
      <div className="addAdmin-subcontainer">
        <FaArrowLeftLong
          style={{ cursor: "pointer" }}
          onClick={() => {
            navigate("/pricing");
          }}
        />
        <div className="add-title">Edit Pricing</div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="addAdmin-content">
          <div className="addAdmin-contentLeft">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Vehicle Type
              </label>
              <div>
                <input
                  type="text"
                  name="vehicle_type"
                  placeholder="Enter Your Vehicle Type"
                  value={formik.values.vehicle_type}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.vehicle_type && formik.errors.vehicle_type && (
                  <div className="text-danger">
                    {formik.errors.vehicle_type}
                  </div>
                )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Ryder Charges
              </label>
              <div>
                <input
                  type="number"
                  name="ryder_charges"
                  placeholder="Enter Your Ryder Charges"
                  value={formik.values.ryder_charges}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.ryder_charges &&
                  formik.errors.ryder_charges && (
                    <div className="text-danger">
                      {formik.errors.ryder_charges}
                    </div>
                  )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Gomak GST
              </label>
              <div>
                <input
                  type="number"
                  name="gomak_gst"
                  placeholder="Enter Your gomak GST"
                  value={formik.values.gomak_gst}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.gomak_gst && formik.errors.gomak_gst && (
                  <div className="text-danger">{formik.errors.gomak_gst}</div>
                )}
              </div>
            </div>
          </div>
          <div className="addAdmin-contentRight">
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Gomak Commision
              </label>
              <div>
                <input
                  type="number"
                  name="gomak_commision"
                  placeholder="Enter Your Gomak Commision"
                  value={formik.values.gomak_commision}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.gomak_commision &&
                  formik.errors.gomak_commision && (
                    <div className="text-danger">
                      {formik.errors.gomak_commision}
                    </div>
                  )}
              </div>
            </div>
            <div className="addAdmin-field">
              <label>
                <span className="text-danger">*</span> Ryder GST
              </label>
              <div>
                <input
                  type="number"
                  name="ryder_gst"
                  placeholder="Enter Your Ryder GST"
                  value={formik.values.ryder_gst}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.ryder_gst && formik.errors.ryder_gst && (
                  <div className="text-danger">{formik.errors.ryder_gst}</div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="addbtnContainer">
          <div>
            <button
              type="button"
              className="admin-btnCancel"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
          </div>
          <div>
            <button className="add-btnSave">Update</button>
          </div>
        </div>
      </form>
    </div>
  );
};
